// Dynamic import to handle bad-words in both development and production
let badWordsFilter: any = null;

// Load bad-words asynchronously
const loadBadWordsFilter = async () => {
  if (!badWordsFilter) {
    try {
      // Use dynamic import for ES modules compatibility
      // @ts-ignore - bad-words doesn't have TypeScript types
      const Filter = (await import('bad-words')).default;
      badWordsFilter = new Filter({
        placeHolder: '•',
        // You can add custom words here if needed
      });
    } catch (error) {
      console.error('Error loading bad-words filter:', error);
      // Return a fallback that always allows content if filter fails to load
      badWordsFilter = {
        isProfane: () => false
      };
    }
  }
  return badWordsFilter;
};

// Pre-load filter immediately
loadBadWordsFilter();

/**
 * Validates text against profanity filter
 * Returns true if inappropriate content is detected
 */
export function containsBlockedWords(text: string): boolean {
  const normalizedText = text.toLowerCase().trim();
  
  if (!normalizedText) return false;
  
  // If filter is not loaded yet, return false (allow the content temporarily)
  // This prevents blocking the UI while the filter loads
  if (!badWordsFilter || typeof badWordsFilter.isProfane !== 'function') {
    // Try to load it if not already loading
    loadBadWordsFilter();
    return false;
  }
  
  // Check against bad-words library
  try {
    return badWordsFilter.isProfane(normalizedText);
  } catch (error) {
    console.error('Error checking profanity:', error);
    // Fail safe - return false to allow the text if filter fails
    return false;
  }
}

/**
 * Get human-friendly error message for profanity detection
 */
export function getProfanityErrorMessage(fieldName: string): string {
  return `${fieldName} contains inappropriate language. Please choose a different ${fieldName.toLowerCase()}.`;
}